import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { AsyncJobService } from '@recruitee/async-job-data';
import { HttpApiService } from '@recruitee/http';

@Injectable({ providedIn: 'root' })
export class LocationsBulkActionsHttpClient {
  constructor(
    protected httpApi: HttpApiService,
    protected asyncJob: AsyncJobService,
  ) {}

  public merge({
    id,
    locationIds,
  }: {
    id: number;
    locationIds: number[];
  }): Observable<{ uuid: string }> {
    return this.httpApi.patch(`/locations/${id}/merge`, null, { locationIds });
  }
}
